<template>
  <div>
    <h2>我的答卷</h2>
    <a-divider></a-divider>
    <a-button type="danger" @click="toMyPaper()" icon="left-circle">返回我的考试</a-button>
    <br><br>
    <a-table
      ref="table"
      bordered
      size="middle"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleReview(record)">查看试卷</a>
      </span>
    </a-table>
  </div>
</template>

<script>
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { getAction } from "@/api/manage";
export default {
  name: "Question",
  mixins: [JeecgListMixin],
  data() {
    return {
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          fixed:"left",
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: "试卷",
          align: "center",
          dataIndex: "paperId_dictText"
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'userPaperStatus_dictText',
          sorter: true
        },
        {
          title: '用时',
          align: 'center',
          dataIndex: 'duration',
          sorter: true,
          customRender(time, row) {
            if (row.userPaperStatus == 0) {
              return ""
            }
            var minutes = Math.floor(time / 60)
            var seconds = Math.floor(time % 60)
            return minutes + ':' + seconds
          },
        },
        {
          title: '总得分',
          align: 'center',
          dataIndex: 'gotScore',
          sorter: true,
          customRender(v){
            if(v==null){
              return '--'
            }else{
              return v
            }
          }
        },
        {
          title: '开考时间',
          align: 'center',
          dataIndex: 'createTime',
          sorter: true,
        },
        {
          title: '交卷时间',
          align: 'center',
          dataIndex: 'submitTime',
          sorter: true,
        },
        // {
        //   title: '批改时间',
        //   align: 'center',
        //   dataIndex: 'reviewTime',
        //   sorter: true,
        // },
        // {
        //   title: '批改人',
        //   align: 'center',
        //   dataIndex: 'reviewUserId_dictText',
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/teaching/teachingUserPaper/myAnswerPaper',
      },
    };
  },
  created() {
  },
  methods: {
    searchQuery(){
      this.loadData();
    },
    toMyPaper(){
      this.$router.push({path: '/user/myPaper'})
    },
    handleReview(record) {
      let path = {
        path: '/user/userPaper',
        query: {
          id: record.id,
        },
      }
      // let route = this.$router.resolve(path)
      // window.open(route.href, '_blank')
      this.$router.push(path)
    },
  },
};
</script>

<style>
</style>